<!-- Loading -->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header compact-header">
  <div class="container-fluid">
    <div class="header-row">

      <a href="javascript:void(0)" (click)="goBack()" class="back-btn">
        <i class="fa fa-arrow-left"></i>
      </a>

      <h5 class="page-title mb-0">
        Vehicle Details
      </h5>

      <a routerLink="/" class="home-btn">
        <i class="fas fa-home"></i>
      </a>
    </div>

  </div>
</section>
<!-- /.content-header -->
<section class="content">
  <div class="container-fluid">

    <div class="card shadow-sm rounded-lg">

      <!-- Header -->
      <div class="card-header">
        <h5 class="mb-0 text-danger font-weight-bold">
          {{vehicle?.data?.make}} {{vehicle?.data?.model}}
        </h5>
      </div>

      <div class="card-body">

        <!-- Alerts -->
        <div class="alert alert-danger" *ngIf="errorMessage">
          {{errorMessage}}
        </div>

        <div class="alert alert-success" *ngIf="successMessage">
          {{successMessage}}
        </div>

        <!-- Carousel -->
        <div id="photoCarousel"
             class="carousel slide mb-4"
             data-ride="carousel">

          <ol class="carousel-indicators">
            <li *ngFor="let photo of photos; let i = index"
                [class.active]="i === 0"
                data-target="#photoCarousel"
                [attr.data-slide-to]="i">
            </li>
          </ol>

          <div class="carousel-inner rounded-lg shadow-sm">
            <div *ngFor="let photo of photos; let i=index"
                 class="carousel-item"
                 [class.active]="i===0">

              <img [src]="photo.image_url"
                   class="d-block w-100 vehicle-img"
                   alt="Vehicle Photo">
            </div>
          </div>

          <a class="carousel-control-prev"
             href="#photoCarousel"
             role="button"
             data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
          </a>

          <a class="carousel-control-next"
             href="#photoCarousel"
             role="button"
             data-slide="next">
            <span class="carousel-control-next-icon"></span>
          </a>

        </div>

        <!-- Details -->
        <div class="vehicle-details row">

          <!-- LEFT COLUMN -->
          <div class="col-6">

              <div class="detail-item">
                  <strong>Chassis No.</strong>&nbsp;
                  {{vehicle.data.chassis_no}}
              </div>

              <div class="detail-item">
                  <strong>Engine CC</strong>&nbsp;
                  {{vehicle.data.engine_cc}}
              </div>

              <div class="detail-item">
                  <strong>Transmission</strong>&nbsp;
                  {{vehicle.data.transmission}}
              </div>

              <div class="detail-item">
                  <strong>Body Type</strong>&nbsp;
                  {{vehicle.data.body_type}}
              </div>

              <div class="detail-item">
                  <strong>Fuel</strong>&nbsp;
                  {{vehicle.data.fuel}}
              </div>

              <div class="detail-item">
                  <strong>Colour</strong>&nbsp;
                  {{vehicle.data.colour}}
              </div>

              <div class="detail-item">
                  <strong>Year</strong>&nbsp;
                  {{vehicle.data.year}}
              </div>

              <div class="detail-item">
                <strong>Drive</strong>&nbsp;
                {{vehicle.data.drive}}
            </div>

          </div>


          <!-- RIGHT COLUMN -->
          <div class="col-6">

              <div class="detail-item">
                  <strong>Mileage</strong>&nbsp;
                  {{vehicle.data.mileage}}
              </div>

              <div class="detail-item" *ngIf="userPermissions.includes('view-sp')">
                  <strong>Price</strong>&nbsp;
                  {{vehicle.data.selling_price}}
              </div>

              <div class="detail-item" *ngIf="userPermissions.includes('view-duty')">
                  <strong>Duty</strong>&nbsp;
                  {{vehicle.data.duty_paid|number}}
              </div>

              <div class="detail-item" *ngIf="userPermissions.includes('view-cnf-app')">
                <strong>CNF</strong>&nbsp;
                {{vehicle.data.cnf_charges|number}}
              </div>

              <div class="detail-item" *ngIf="userPermissions.includes('view-ot-chg')">
                  <strong>Other Charges</strong>&nbsp;
                  {{vehicle.data.other_charges|number}}
              </div>

              <div class="detail-item" *ngIf="userPermissions.includes('view-ttl-cst')">
                <strong>Total Cost</strong>&nbsp;
                {{vehicle.data.total_cost|number}}
              </div>

              <div class="detail-item">
                  <strong>Status</strong>&nbsp;
                  {{vehicle_status}}
              </div>

              <div class="detail-item">
                  <strong>Location</strong>&nbsp;
                  {{vehicle.data.location}} - {{vehicle.data.branch}}
              </div>

          </div>
      </div>

        <!-- Action Buttons -->
        <div class="row mt-2">
          <div class="col-6" *ngIf="userPermissions.includes('transfer-vhcl') || userPermissions.includes('receive-vhcl')">
            <button class="btn btn-success btn-block rounded-pill" (click)="checkVehicleStatus(vehicle.data.vehicle_id)">
              <i class="fas fa-exchange-alt"></i>
              Transfer/Receive
            </button>
          </div>

          <div class="col-6" *ngIf="userPermissions.includes('mob-upd-spare-parts')">
            <button class="btn btn-success btn-block rounded-pill" (click)="updateSpareParts(vehicle.data.vehicle_id)">
              <i class="fas fa-edit"></i>
              Update Spare Parts
            </button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6" *ngIf="userPermissions.includes('transfer-vhcl') && vehicle.data.status==2">
            <button class="btn btn-success btn-block rounded-pill" (click)="deliverToCustomer(vehicle.data.vehicle_id)">
              <i class="fas fa-camera"></i>
              Deliver To Customer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
